// Water.js
import * as React from "react";
import { Box, useTheme } from "@mui/material";
import "./Raindrops.css";

const arange = (n, fn) => Array.from({ length: n }).map((_, i) => fn(i));
const uniform = (min, max) => Math.random() * (max - min) + min;

export const Raindrop = ({ 
  duration = 3.1, 
  // rotation = '90deg', 
  delay, height, 
  durationVariation = 0.2,
  dropletSizeVariation = 0.2,
  splashHeight = '40px',  
  groundAngle = '60deg',

  rippleScale = 7.5,
  rippleSpacing = 0.02,
  nRipples = 1, 
  nParticles = 3
}) => {
  const random = React.useMemo(() => Math.random(), []);

  duration = React.useMemo(() => duration * (1 + (Math.random() - 0.5) * 2 * durationVariation), [duration, durationVariation]);
  delay = React.useMemo(() => delay || `calc(-${Math.random() * 2} * ${duration}s)`, [delay, duration]);
  height = React.useMemo(() => height || `${Math.random() * 100}%`, [height]);
  const opacity = React.useMemo(() => 0.5 + Math.random() * 0.5, []);
  const dropletScale = React.useMemo(() => uniform(1 - dropletSizeVariation, 1 + dropletSizeVariation), [dropletSizeVariation]);

  return (
    <div className="raindrop" style={{ 
        bottom: height,
        
        '--duration': `${duration}s`,
        '--delay': delay,
        // '--depth': '-500px',
        '--depth': `-${random * 300}px`,
        '--ground-angle': groundAngle,

        '--rain-opacity': opacity,
        '--droplet-scale': dropletScale,
        
        '--splash-height': splashHeight,
        '--ripple-scale': rippleScale,
        // '--ground-rotation': rotation,
    }}>
      {arange(nRipples, (i) => (
        <div key={i} className="ripple" style={{
          '--ripple-index': i,
          '--opacity': 0.55 - i * 0.1,
          '--ripple-spacing': rippleSpacing,
          '--delay': `calc(${delay} + ${i * 0.03} * ${duration}s)`,
        }}></div>
      ))}
      <div className="droplet"></div>
      <div className="splash">
        {arange(nParticles, (i) => (
          <div key={i} className='particle' style={{
            '--particle-index': i,
            '--splash-delay-offset': uniform(-0.1, 0.1),
            '--splash-particle-scale': uniform(0.5, 1.5),
            '--splash-direction': uniform(-1, 1),
          }}></div>))}
      </div>
    </div>
  );
};

const Raindrops = ({ 
    nDrops = 32, 
    dropletHeight = '20px',
    dropletWidth = '3px',
    rainAngle = '0deg',
    color,
    ...props 
}) => {
  const theme = useTheme();
  color = color || theme.palette.primary.solidBg;
  return (
    <div className="raindrops" style={{
      '--color': color,
      '--rain-angle': rainAngle,
      '--rain-height': dropletHeight,
      '--rain-width': dropletWidth,
    }}>
      <div className="ground">
        {arange(nDrops, (i) => (<Raindrop key={i} {...props} />))}
      </div>
    </div>
  );
};

export default Raindrops;
